module.exports = __webpack_public_path__ + "img/warn.c845a48e.svg";